import classNames from 'classnames'
import React, { Children } from 'react'

export interface ViewContentProps {
  children: React.ReactNode
  className?: string
}

const ViewContent: React.FC<ViewContentProps> = (props) => {
  const { children, className } = props
  const content = Children.only(children)

  return (
    <div
      className={classNames(
        'bg-white max-w-full mt-10',
        'tablet:border tablet:border-common-gray-4 tablet:rounded-lg tablet:p-6',
        'desktop:p-7 desktop:pb-16 desktop:mb-32 desktop:-mt-28',
        'desktop:rounded-lg desktop:drop-shadow-as desktop:col-span-2',
        className
      )}
    >
      {content}
    </div>
  )
}

export default ViewContent
